import {createFeatureSelector, createSelector} from "@ngrx/store";
import {IBackupLimitsState} from "../reducers/backup-limits.reducer";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getBackupLimitsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.backupLimits);

export const getBackupLimits = createSelector(getBackupLimitsState,
  (state: IBackupLimitsState) =>
    state.backupLimits ? state.backupLimits : null
);

export const getBackupLimitsLoading = createSelector(getBackupLimitsState,
  (state: IBackupLimitsState) =>
    state.loading
);

export const getBackupLimitsLoaded = createSelector(getBackupLimitsState,
  (state: IBackupLimitsState) =>
    state.loaded
);
